import React from "react";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";

import styles from "./mapFinishMarker.module.scss";

const MapFinishMarker = (props) => {
  const { position, onClick } = props;
  const markerIcon = L.divIcon({
    iconSize: [53, 63],
    iconAnchor: [26, 63],
    popupAnchor: [0, -63],
    className: styles.mapFinishMarker,
    html: '<div class="' + styles.inner + '">Конец</div>',
  });

  return (
    <Marker
      position={position}
      icon={markerIcon}
      eventHandlers={{
        click: onClick,
      }}
    >
      {props.children}
      <Popup className="mapPopup" />
    </Marker>
  );
};

export default React.memo(MapFinishMarker);
